export default __webpack_public_path__ + "static/media/romance2.d6bf0212.jpg";